import React, { useState } from "react";
import { setTitle } from "../helpers/MetaTag";
import Input from "../components/form/Input";
import Button from "../components/form/Button";
import { Link } from "react-router-dom";
import toastr from "toastr";
import { useNavigate } from "react-router";

import { postData } from "../services/api";
import { useTranslation } from "react-i18next";
import { MAIN_LOGO } from "../constant/Constant";
import Image from "../components/elements/Image";

const ForgotPassword = () => {
  setTitle(
    "Succession Planning Software for your Business with Succession Now | Forgot Password"
  );
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isCheck, setIsCheck] = useState(1);
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const [isVerify, setIsVerify] = useState(false);
  const [isResendOtp, setIsResendOtp] = useState(false);
  const [countDown, setCountDown] = useState("Resend code:(00:00)");
  const [isDisabled, setIsDisabled] = useState(false);
  const [isChangePassword, setIsChangePassword] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setIsForgotPassword(true);
    try {
      const userData = await postData("forgot-password", {
        email: email,
      });
      if (userData.status && userData.status === 200) {
        setIsForgotPassword(false);
        //setIsCheck(2);
        //otpCounter();
        toastr.success(userData.message);
      } else {
        toastr.error(userData.message);
        setIsForgotPassword(false);
      }
    } catch (error) {
      toastr.error(error.message);
      setIsForgotPassword(false);
    }
  };

  const onVerify = async (e) => {
    e.preventDefault();
    setIsVerify(true);
    try {
      const userData = await postData("verify-otp", {
        email: email,
        otp: otp,
      });
      if (userData.status && userData.status === 200) {
        setIsVerify(false);
        setIsCheck(3);
        setOtp("");
        toastr.success(userData.message);
      } else {
        toastr.error(userData.message);
        setIsVerify(false);
      }
    } catch (error) {
      toastr.error(error.message);
      setIsVerify(false);
    }
  };

  const onResendOtp = async (e) => {
    e.preventDefault();
    setIsResendOtp(true);
    try {
      const userData = await postData("resend-otp", {
        email: email,
      });
      if (userData.status && userData.status === 200) {
        setIsResendOtp(false);
        toastr.success(userData.message);
      } else {
        toastr.error(userData.message);
        setIsResendOtp(false);
      }
    } catch (error) {
      toastr.error(error.message);
      setIsResendOtp(false);
    }
  };

  const onChangePassword = async (e) => {
    e.preventDefault();
    setIsChangePassword(true);
    try {
      const userData = await postData("reset-password", {
        email: email,
        password: password,
        confirm_password: confirmPassword,
      });
      if (userData.status && userData.status === 200) {
        setIsChangePassword(false);
        toastr.success(userData.message);
        return navigate("/signin");
      } else {
        toastr.error(userData.message);
        setIsChangePassword(false);
      }
    } catch (error) {
      toastr.error(error.message);
      setIsChangePassword(false);
    }
  };

  // const otpCounter = () => {
  //   setIsDisabled(true);
  //   const count_time5 = add_minutes(new Date(), 1).toLocaleString("en-US", {
  //     timeZone: "Asia/Kolkata",
  //   });
  //   const count_time20 = new Date(count_time5).getTime();
  //   const x20 = setInterval(function () {
  //     const timezone20 = new Date().toLocaleString("en-US", {
  //       timeZone: "Asia/Kolkata",
  //     });
  //     const now20 = new Date(timezone20).getTime();
  //     const distance20 = count_time20 - now20;
  //     const days20 = Math.floor(distance20 / (1000 * 60 * 60 * 24));
  //     const hours20 = Math.floor(
  //       (distance20 % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  //     );
  //     const minutes20 = Math.floor(
  //       (distance20 % (1000 * 60 * 60)) / (1000 * 60)
  //     );
  //     const seconds20 = Math.floor((distance20 % (1000 * 60)) / 1000);
  //     setCountDown(
  //       "Resend code:(" +
  //         ("0" + minutes20).slice(-2) +
  //         ":" +
  //         ("0" + seconds20).slice(-2) +
  //         ")"
  //     );
  //     if (distance20 < 0) {
  //       clearInterval(x20);
  //       setCountDown(t("resend_code"));
  //       setIsDisabled(false);
  //     }
  //   }, 1000);
  // };

  const add_minutes = (dt2, minutes2) => {
    return new Date(dt2.getTime() + minutes2 * 60000);
  };

  return (
    <>
      <div className="min-h-screen bg-gray-100 flex flex-col justify-center">
        <div className="relative py-3 max-w-[288px] sm:max-w-md mx-auto w-full ">
          <div className="absolute inset-0 bg-gradient-to-r from-teal-500 to-teal-600 shadow-lg transform -skew-y-6 sm:skew-y-0 -rotate-6 rounded-3xl"></div>
          <div className="relative px-4 py-10 bg-white shadow-lg rounded-3xl ">
            <Link to={"/"}>
              <div className="h-10 sm:h-14 w-full flex justify-center object-contain mb-5">
                <Image
                  src={MAIN_LOGO}
                  alt={""}
                  width={"100%"}
                  height={"100%"}
                  classes={"object-contain object-center"}
                />
              </div>
            </Link>
            {isCheck && isCheck === 1 ? (
              <div className="max-w-64 sm:max-w-xs mx-auto ">
                <div className="relative">
                  <h1 className="text-lg sm:text-2xl font-bold text-center text-slate-700">
                    {t("forgot_password")}
                  </h1>
                  <div className="text-sm sm:text-base text-slate-900 text-center font-medium">
                    {t("please_use_your_credentials_to_forgot_password")}
                  </div>
                </div>
                <form className="space-y-2 sm:space-y-4 w-full">
                  <div className="relative z-0 w-full group">
                    <Input
                      inputType={"email"}
                      inputClasses={
                        "block h-10 !px-0 w-full text-sm text-gray-900 bg-transparent !border-0 !border-b-2 !rounded-none border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-teal-500 peer"
                      }
                      inputPlaceholder={t("email_address")}
                      inputValue={email}
                      setInput={setEmail}
                    />
                  </div>
                  <div className="relative flex justify-center !mt-8">
                    <Button
                      buttonClasses=""
                      buttonLabelClasses=""
                      buttonType={"button"}
                      buttonIcon={
                        isForgotPassword
                          ? "fa-light fa-spinner fa-spin"
                          : "fa-light fa-arrow-right-to-arc"
                      }
                      buttonIconPosition={"left"}
                      buttonLabel={t("forgot_password")}
                      functions={onSubmit}
                      buttonHasLink={false}
                      buttonDisabled={isForgotPassword}
                    />
                  </div>
                </form>
                <div className="flex gap-1 item-center justify-center text-slate-400 text-sm pt-4">
                  {t("already_have_a_account")}
                  <Link to={"/signin"} className="text-teal-500 font-semibold">
                    {t("signin")}
                  </Link>
                  {t("here")}
                </div>
              </div>
            ) : isCheck && isCheck === 2 ? (
              <div className="max-w-64 sm:max-w-xs mx-auto ">
                <div className="flex gap-1 item-center justify-center ">
                  {/* <h1 className="text-xl font-semibold text-center text-slate-700">Verification code</h1> */}
                  <div className="text-sm sm:text-base text-slate-900 text-center font-medium">
                    {t("please_check_your_email_to_verify_your_account")}
                  </div>
                </div>
                <form className="space-y-2 sm:space-y-4 w-full">
                  <div className="relative z-0 w-full group">
                    <Input
                      inputClasses={
                        "block h-10 !px-0 w-full text-sm text-gray-900 bg-transparent !border-0 !border-b-2 !rounded-none border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-teal-500 peer"
                      }
                      inputType={"number"}
                      inputPlaceholder={t("enter_verification_code")}
                      inputValue={otp}
                      setInput={setOtp}
                      errorType={"info"}
                      errorText={countDown}
                    />
                  </div>
                  <div className="relative flex justify-center gap-2 !mt-8">
                    <Button
                      buttonClasses=""
                      buttonLabelClasses=""
                      buttonType={"button"}
                      buttonIcon={
                        isVerify
                          ? "fa-light fa-spinner fa-spin"
                          : "fa-light fa-arrow-right-to-arc"
                      }
                      buttonIconPosition={"left"}
                      buttonLabel={t("submit")}
                      functions={onVerify}
                      buttonHasLink={false}
                      buttonDisabled={isVerify}
                    />
                    <Button
                      buttonLabelClasses=""
                      buttonClasses={
                        isDisabled
                          ? "!bg-slate-200 !text-slate-600 border border-slate-300 pointer-events-none"
                          : ""
                      }
                      buttonType={"button"}
                      buttonIcon={
                        isResendOtp
                          ? "fa-light fa-spinner fa-spin"
                          : "fa-light fa-clock"
                      }
                      buttonIconPosition={"left"}
                      buttonLabel={t("resendcode")}
                      functions={onResendOtp}
                      buttonHasLink={false}
                      buttonDisabled={isDisabled}
                    />
                  </div>
                </form>
              </div>
            ) : (
              <div className="max-w-64 sm:max-w-xs mx-auto ">
                <div className="relative">
                  <h1 className="text-lg sm:text-2xl font-bold text-center text-slate-700">
                    {t("change_password")}
                  </h1>
                  <div className="text-sm sm:text-base text-slate-900 text-center font-medium">
                    {t("please_use_your_credentials_to_update_password")}
                  </div>
                </div>
                <form className="space-y-2 sm:space-y-4 w-full">
                  <div className="relative z-0 w-full group">
                    <Input
                      inputClasses={
                        "block h-10 !pl-0 !pr-8 w-full text-sm text-gray-900 bg-transparent !border-0 !border-b-2 !rounded-none border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-teal-500 peer"
                      }
                      inputType={"password"}
                      inputPlaceholder={t("new_password")}
                      inputValue={password}
                      setInput={setPassword}
                      //errorType={''}
                    />
                  </div>
                  <div className="relative z-0 w-full group">
                    <Input
                      inputClasses={
                        "block h-10 !pl-0 !pr-8 w-full text-sm text-gray-900 bg-transparent !border-0 !border-b-2 !rounded-none border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-teal-500 peer"
                      }
                      inputType={"password"}
                      inputPlaceholder={t("confirm_password")}
                      inputValue={confirmPassword}
                      setInput={setConfirmPassword}
                      //errorType={''}
                    />
                  </div>
                  <div className="relative flex justify-center !mt-8">
                    <Button
                      buttonClasses=""
                      buttonLabelClasses=""
                      buttonType={"button"}
                      buttonIcon={
                        isChangePassword
                          ? "fa-light fa-spinner fa-spin"
                          : "fa-light fa-arrow-right-to-arc"
                      }
                      buttonIconPosition={"left"}
                      buttonLabel={t("change_password")}
                      functions={onChangePassword}
                      buttonHasLink={false}
                      buttonDisabled={isChangePassword}
                    />
                  </div>
                </form>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
